export const MuiCssBaseline = {
  '@global': {
    'html, body, #root': {
      padding: 0,
      height: '100%',
    },
  },
};
